import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import DemoTable from './DemoTable'
import ImgMediaCard from '../common/FeatureCard'
const BackgroundImg = require ('./../../images/graphics/nurse_ipad_reception.png')


// ADMIN MENU DATA ------------------------------------

const admin_menu_data = [
    {
        title: 'Residents',
        link:'',
        desc:'',
        data:[

        ]
    },
    {
        title: 'Users',
        link:'',
        desc:'',
    },
    {
        title: 'Clinicians',
        link:'',
        desc:'',
    },
    {
        title: 'Pharmacies',
        link:'',
        desc:'',
    },
    {
        title: 'Prescriptions',
        link:'',
        desc:'',
    },
    {
        title: 'Labs',
        link:'',
        desc:'',
    },
    {
        title: 'Activity',
        link:'',
        desc:'',
    },
    {
        title: 'Vitals',
        link:'',
        desc:'',
    },
]
// CARD DATA ------------------------------------

const cards_data = [
  {
    title: 'Care Information',
    image_path: 'smart_health.png',
    text: 'Our platform helps care practitioners manage senior residents in assisted living with advanced care information.',
    link: '/about',
  },
  {
    title: 'Resident Facilities',
    image_path: 'living_facility.jpg',
    text: 'We develop tools to supervise building data and other information for care facility to ensure all topics are operational and meeting specifications.',
    link: '/about',
  },
  {
    title: 'Innovation Partners',
    image_path: 'health_data_network.jpg',
    text: 'Connect with us to learn more about the exciting solutions we are developing as pioneers in next generation technology-driven care solutions.',
    link: '/contact',
  },
]
// TAB PANEL ------------------------------------

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


// CSS STYLES ------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    textAlign: 'left',
    '& header': {
      background: '#ffffff',
      background: '-moz-linear-gradient(top,  #ffffff 0%, #e6eff4 100%)',
      background: '-webkit-linear-gradient(top,  #ffffff 0%,#e6eff4 100%)',
      background: 'linear-gradient(to bottom,  #ffffff 0%,#e6eff4 100%)',
      filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffff", endColorstr="#e6eff4",GradientType=0 )',
      color: '#8795a5',
    },
  },
  bar: {
    background: '#5592de',
  },
  tabpanel:{
      '& h2':{
        color: '#436f96',
        textAlign:'left',
      }
  },
  app_features:{
    padding: 10,
    margin: 10,
    backgroundColor: '#dde6ec',
  },
  intro:{
    padding: '20px 40px',
    color: '#fff',
    //color: '#000',
    textShadow: '1px 3px 4px #025',
    //textShadow: '2px 2px 5px #def',
    background: 'rgba(34, 78, 111, 0.6)',
    //background: 'rgba(255,255,255,.5)',
    '& p': {
      padding: '10px 0',
      borderTop: '1px solid #ccc',
      borderBottom: '1px solid #ccc',
    }
  },
  homesplash:{
      backgroundSize: 'cover',
      backgroundPosition: 'center 79%',
      backgroundImage: `url(${BackgroundImg})`,
      width: '100%',
      height: 300,
  }
}));


// MAIN COMPONENENT ------------------------------------
export default function HomePage() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const cardset = cards_data.map((item, index) =>
    //<Link to={'/admin/'+item.link}> <Tab key={index} value={index} label={item.title} {...a11yProps(index) }>{item.title}</Tab> </Link>
    <Grid item xs={12} md={4}>
      <ImgMediaCard {...item} />
    </Grid>
    )

  return (
    <div className={classes.root}>
        <div className={classes.homesplash}>
        <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
                <div className={classes.intro}>
                    <h3>Spectator Health - <br/>Healthcare Innovation Technologies</h3>
                    <p>Spectator Health develops leading edge technology for improving quality of care experience with patient and resident centric platforms integrating various participants and systems across the healthcare landscape.</p>
                </div>
            </Grid>
        </Grid>
      </div>

      <Paper variant="outlined" className={classes.app_features} >
      <Grid container spacing={2}>
      {cardset}
       
        </Grid>
     </Paper>
    </div>
  );
}